<template>
  <v-row class="mt-0">
    <v-col cols="12" class="pt-0 pb-2">
      <div class="text-right filter-chips">
        <template v-for="(chip, i) in chips">
          <v-chip
            v-show="chip.visible"
            :key="i"
            class="filter-chip ml-1"
            outlined close small color="primary"
            :title="chip.name"
            @click:close="resetFilter(chip)"
          >
            {{ chip.value }}
          </v-chip>
        </template>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FilterChips',

  props: {
    chips: {
      type: Array,
      default: null,
    },
  },

  methods: {
    resetFilter(chip) {
      this.$emit('resetFilter', chip)
    },
  },
}
</script>

<style scoped lang="scss">
.filter-chips >>> .v-chip .v-chip__close.v-icon {
  font-size: 16px !important;
}

.filter-chip {
  cursor: help;
  margin-bottom: 2px;
}
</style>
